import { MaintenanceDate } from "../../../../model/maintenance-schedule.model";
import { MaintenanceDto } from "../../generated";

export const maintenanceDateMapper = (maintenanceDto: Required<MaintenanceDto> | undefined): MaintenanceDate | null => {
    if (maintenanceDto) {
        return {
            maintenanceStartDate: new Date(maintenanceDto.start),
            maintenanceEndDate: new Date(maintenanceDto.end),
        }
    }
    return null;
}